import { DataBean } from "../DataBean";

export class ImportBankingCheck extends DataBean {



    public async ImportBankingCheckList(idBankingAccount: any, filename: any, directory: any, dataStore: any,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importBankingCheckList_Number_String_String_String", [idBankingAccount, filename, directory, dataStore]);
    }

}